export class PageParams {
  private disabledOptionVisible:boolean = true;
  private showDelete:Boolean = true;
  private onDeleteMessage:string = "";

  constructor(private title: string = "",
              private subtitle: string = "") {
  }


  setDisabledOptionVisible(v:boolean) {
    this.disabledOptionVisible = v;
    return this;
  }


  getDisabledOptionVisible() {
    return this.disabledOptionVisible;
  }


  setTitle(title: string) {
    this.title = title;
    return this;
  }


  getTitle(): string {
    return this.title;
  }

  setSubtitle(subtitle: string) {
    this.subtitle = subtitle;
    return this;
  }


  getSubtitle() {
    return this.subtitle;
  }

  setShowDelete(val:boolean){
    this.showDelete = val;
  }

  getShowDelete(){
    return this.showDelete;
  }

  setOnDeleteMessage(msg:string)
  {
    this.onDeleteMessage = msg;
  }

  getOnDeleteMessage()
  {
    return this.onDeleteMessage;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/params/page-params.ts